/*
 * Editorial pages (Our Story, Our Founder, Our Credentials, Wholesale & Partnerships).
 * Fade / rise reveal on scroll, played once per element. Respects prefers-reduced-motion.
 * Safe to load once per page: elements already revealed are skipped.
 */
(function () {
  function init() {
    var revealEls = document.querySelectorAll('.olive-ed .reveal:not(.in)');
    if (!revealEls.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) {
        el.classList.add('in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var delay = entry.target.dataset.staggerIndex
            ? Number(entry.target.dataset.staggerIndex) * 90
            : 0;
          setTimeout(function () {
            entry.target.classList.add('in');
          }, delay);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    revealEls.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections in place; re-run so new elements reveal.
  document.addEventListener('shopify:section:load', init);
})();
